import { ActivationBlock } from './activation-block';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';

/** `matrix-activation-levier-names`: the activation block with its names hidden, in a column, or in a thin band. */
export function ActivationNamesPreview({ value }: SettingPreviewProps) {
  return (
    <PreviewFrame>
      <ActivationBlock names={value} treatment="off" />
    </PreviewFrame>
  );
}
